import { render, staticRenderFns } from "./recommended-locations.vue?vue&type=template&id=3bd16ef6&scoped=true"
import script from "./recommended-locations.vue?vue&type=script&lang=js"
export * from "./recommended-locations.vue?vue&type=script&lang=js"
import style0 from "./recommended-locations.vue?vue&type=style&index=0&id=3bd16ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd16ef6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
